module.exports = __webpack_public_path__ + "img/2.e986f989.png";